export default "__VITE_ASSET__49ae6846__"